// @ts-nocheck
import React, { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import Client from '../tw/client'
import PageLoader from '../components/Loader/PageLoader'
import { OCR_STREAM, SELECTED_SUBJECT, SELECTED_UNIT } from '../utils/constants'

import { useTenant } from '../hooks/useTenant'
import { INTERNATIONAL_STREAM } from '../utils/constants'
import { useRecoilState, useRecoilValue } from 'recoil'
import { sessionSelector, getLogoutUrl } from '../state/session'

const LogoutPage = () => {
	const [restoredSession, setSession] = useRecoilState(sessionSelector)
	let redirectTo = localStorage.getItem('logout_redirect')
	const isCi = useTenant() === 'ci'
	const [searchParams, setSearchParams] = useSearchParams()

	useEffect(() => {
		const logout = async () => {
			const redirectUrl =
				searchParams.get('redirect_uri') || window.location.origin
			try {
				const { selectedBusinessStream: stream, client_id: clientId } =
					restoredSession
				let url = getLogoutUrl(stream)
				const params = new URLSearchParams({
					redirect_uri: redirectUrl,
					client_id: clientId
				})
				url = `${url}?${params.toString()}`
				await Client.logout()
				window.location.assign(url)
			} catch (error) {
				console.error('Error logging out:', error)
			}
		}
		logout()
	}, [])

	return (
		<div>
			<PageLoader />
		</div>
	)
}

export default LogoutPage
